import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchDashboardCountRequest } from "../ipsStore/actions";
import GenericDashboardScreen from "../components/GenericDashboardScreen";
import VilIcon from "../../../assets/images/TravelRequest.svg";
import DashboardBG from "../../../assets/images/Dashboard_bg.svg";

const VIL = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCardClick = (label) => {
    navigate(`/vil_requests-patient_list?label=${encodeURIComponent(label)}`, {
      state: { label },
    });
  };

  const handleDateFilterApply = (dateRange) => {
    let payload = new FormData();
    payload.append("from_date", dateRange.fromDate);
    payload.append("to_date", dateRange.toDate);
    payload.append("screen", "vil_requests");
    payload.append("source", "Web");
    dispatch(fetchDashboardCountRequest(payload));
  };

  return (
    <GenericDashboardScreen
      header="VIL Requests"
      screenIcon={VilIcon}
      iconUrl={"/home"}
      showDateFilters={true}
      bgImage={DashboardBG}
      fetchAction={fetchDashboardCountRequest}
      dataSelector={(state) => state.ips.dashboardCount?.vil_requests}
      screenName="vil_requests"
      handleCardClick={handleCardClick}
      dateFilterHandler={handleDateFilterApply}
    />
  );
};

export default VIL;
